import styled from '@emotion/styled';

export const RowRoot = styled.div<{ $focused: boolean; $disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 8px 8px 8px;
  padding: 4px;
  border-radius: 4px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  background: ${({ $focused }) => ($focused ? 'var(--dk-bg-muted, #F3F5F6)' : 'transparent')};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};

  &:hover {
    background: ${({ $disabled }) => ($disabled ? 'transparent' : 'var(--dk-bg-muted, #F3F5F6)')};
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Avatar = styled.div`
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--dk-bg-muted, #eceef1);
  color: var(--dk-text-strong, #637381);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  overflow: hidden;

  & > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

export const Identity = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  min-width: 0;
  flex: 1 1 auto;
`;

export const NameLine = styled.div`
  display: flex;
  align-items: baseline;
  gap: 6px;
  min-width: 0;
`;

export const NameText = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: var(--dk-text, #000);
  line-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  & > .match {
    color: var(--dk-accent, #0066cc);
  }
`;

export const PositionText = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: var(--dk-text, #212b36);
  line-height: 20px;
`;

export const DeptText = styled.span`
  font-size: 12px;
  color: var(--dk-text-strong, #637381);
  line-height: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CheckSlot = styled.div`
  flex: 0 0 auto;
`;
